import { render, staticRenderFns } from "./CustomFieldForm.vue?vue&type=template&id=2944b1df&scoped=true"
import script from "./CustomFieldForm.vue?vue&type=script&lang=js"
export * from "./CustomFieldForm.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldForm.vue?vue&type=style&index=0&id=2944b1df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2944b1df",
  null
  
)

export default component.exports